export const CALCULATOR_NAME = 'Torty Prostokątne'
export const PROVIDE_CALCULATOR_LENGTH = 'Podaj długość tortu'
export const PROVIDE_CALCULATOR_WIDTH = 'Podaj szerokość tortu'
export const PROVIDE_CALCULATOR_HEIGHT = 'Podaj wysokość tortu'
export const CHOOSE_TYPE_OF_CREAM = 'Wybierz rodzaj kremu'
export const CAKE_COMPOSITIONS = 'Skład kremu'
